import { Descriptions } from "antd"
import React, { memo, useEffect, useState } from "react";
import { SearchSingleFormModel, SingleInvoiceInfoModel } from "../../../../../model/searchInvoiceModels";
import useSearchInvoiceService from "../../../../../helper/services/searchInvoiceServices";

const InvoiceInfo: React.FC<SearchSingleFormModel> = (props) => {
    const invoiceService = useSearchInvoiceService();
    const [invoiceInfo, setInvoiceInfo] = useState<SingleInvoiceInfoModel | null>();
    useEffect(() => {
        if (!props.taxCode || !props.securityCode) return;
        invoiceService.getInvoiceInfo(props.taxCode, props.securityCode)
            .then(setInvoiceInfo)
    }, [JSON.stringify(props)])

    return (<Descriptions size="small" column={2} bordered>
        <Descriptions.Item label="Ký hiệu">{invoiceInfo?.inv_invoiceSeries}</Descriptions.Item>
        <Descriptions.Item label="Ngày hóa đơn">{invoiceInfo?.inv_invoiceIssuedDate}</Descriptions.Item>
        <Descriptions.Item label="Số hóa đơn">{invoiceInfo?.inv_invoiceNumber?.toString()}</Descriptions.Item>
        <Descriptions.Item label="Tổng tiền	">{new Intl.NumberFormat('vi-VI', { style: 'currency', currency: 'VND' }).format(invoiceInfo?.inv_TotalAmount ?? 0)}</Descriptions.Item>
    </Descriptions>)
}
export default memo(InvoiceInfo)